import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "currency", "interval", "amount"]

  open(event) {
    const { currency, interval, amount } = event.currentTarget.dataset
    this.currencyTarget.value = currency
    this.intervalTarget.value = interval
    this.amountTarget.value = amount
    this.currencyTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.dialogTarget.showModal()
    this.amountTarget.focus()
    this.amountTarget.select()
  }

  close() {
    this.dialogTarget.close()
  }

  stop(event) {
    event.stopPropagation()
  }
}
